// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__11pyy","signatureButtonsRight":"ModalSign_signatureButtonsRight__DZhC3"};